<template>
	<div class="q_pad_lr15px q_mar_t15px">
		<div class="q_pad_tb10px q_bor_bottom q_mar_b15px">
			<van-row>
			  <van-col span="12" class="q_center">
				  <div class="q_text_l q_bold q_color_default">{{userMoney==null?0:userMoney}}元</div>
				  <div class="q_mar_t5px q_text_m">我已捐赠</div>
			  </van-col>
			  <van-col span="12" class="q_center">
				  <div class="q_text_l q_bold q_color_default">{{number}}个项目</div>
				  <div class="q_mar_t5px q_text_m">我已支持</div>
			  </van-col>
			</van-row>
		</div>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功"  v-if="!showEmpty">
      <van-list
          v-model:loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          error-text="请求失败，点击重新加载"
      >
		<div class="q_vertical_left q_mar_b15px" style="width: 100%" v-for="item in list" @click="goToSpeeddea(item.id)">
			<div class="q_inlineblock q_po_re">
        <span v-if="item.state == '1'" class="q_speed_type">已停止</span>
        <span v-if="item.state == '2'" class="q_speed_type">已结束</span>
				<van-image class="q_speed_img" fit="cover"
					:src="item.pic" />
			</div>
			<div class="q_mar_l15px q_inlineblock" style="width: 100%;">
				<div class="q_text_m q_bold q_moit2 q_justify">{{item.ittle}}</div>
				<div class="q_mar_t20px">
					<div class="q_speed q_inlineblock q_veralign_middle" style="width: 60%;">
						<span class="q_text_s q_color_gray">{{item.percentage}}%</span>
						<span class="q_text_s q_color_gray q_flo_right">{{item.sumMoney}}元</span>
						<div class="q_speed_b">
							<div :style="{width: item.percentage + '%'}" class="q_speed_t"></div>
						</div>
					</div>
					<!-- 日期年月日即可，不用到时分秒。搁不哈 -->
					<div class="q_text_s q_color_gray q_inlineblock q_veralign_middle q_right"
						style="width: 40%;">{{item.createTime}}</div>
				</div>
			</div>
		</div>

      </van-list>

    </van-pull-refresh>
    <!--空数据-->
    <div class="q_center" style="margin-top: 26vh;" v-if="showEmpty">
      <img src="@/assets/image/none.png" style="width: 26vw;"/>
      <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
    </div>
	</div>
</template>

<script>
  import {listDonation} from "@/api/donation";
  import {getUserDonation, myDonation} from "@/api/userDonation";
  import {wxCloseShare} from "@/utils/jiutang";

  export default {
		name: 'Speedlist',
		props: {
			msg: String
		},
		data() {
			return {
        showEmpty: false,
        refreshing: false,
        loading: false,
        finished: false,
        list: [],
        pageParam: {
          pageNum: 0,
          pageSize: 5,
        },
        userMoney:0,
        number:0
      }
		},
    created() {
      // wxCloseShare()
      this.init()
    },
    methods: {
      /**
       * 初始化
       */
      init(){
        myDonation().then((res)=>{
          this.number = res.data.number
          this.userMoney = res.data.userMoney
        })
      },
      /**
       * 下拉刷新
       */
      onRefresh() {
        this.pageParam = {
          pageNum: 0,
          pageSize: 5,
        }
        // 清空列表数据
        this.finished = false
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true
        this.onLoad()
      },
      /**
       * 下滑加载更多
       */
      onLoad() {
        this.pageParam.pageNum++
        if (this.pageParam.pageNum == 1) {
          this.$modal.loading()
        }
        //查询募捐项目信息列表
        listDonation(this.pageParam).then(res => {
          console.log('res',res)
          if (res.total == 0) {
            this.showEmpty = true
          }
          //是否下拉刷新
          if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
          }
          for (let i = 0; i < res.rows.length; i++) {
            //处理创建时间
            res.rows[i].createTime = res.rows[i].createTime.substring(0,10)
            res.rows[i].percentage =  ((res.rows[i].money/res.rows[i].sumMoney)*100).toFixed(2)
            this.list.push(res.rows[i]);
          }

          // 加载状态结束
          this.loading = false;

          // 数据全部加载完成
          if (this.list.length >= res.total) {
            this.finished = true;
          }
        }).finally(() => {
          this.$modal.closeLoading()
        })
      },
			goToSpeeddea(id) {
				this.$router.push({
					path: '/home/Speeddea', query: {id: id}
				});
			},
		},
	}
</script>
<style scoped="scoped">
	.q_speed_img {
		width: 110px;
		height: 110px;
	}

	.q_speed_img>>>.van-image__img {
		border-radius: 5px;
	}

	.q_speed_b {
		background-color: #F2F3F7;
		width: 100%;
		height: 6px;
		border-radius: 3px;
		position: relative;
	}

	.q_speed_t {
		background-color: #FF5733;
		width: 10%;
		height: 6px;
		border-radius: 3px;
		position: absolute;
		top: 0px;
		left: 0;
	}
</style>
